import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

import {
  TriggerButton,
  PopupOverlay,
  PopupContainer,
  PopupHeader,
  CloseButton,
  PopupContent,
  SearchInput,
  UserList,
  UserOption,
  RadioInput,
  UserLabel,
  PopupFooter,
  ConfirmButton,
  RemoveWriter,
  SelectedWriter,
  SelectedWriterName,
  LoadingContainer,
  Spinner,
  Title,
} from './styles';

import { NamedCommunityService } from 'services/named';

export default function CommentatorSelect({ onSelectWriter }) {
  const [isOpen, setIsOpen] = useState(false);
  const [focusedUser, setFocusedUser] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchCommentWriters();
  }, []);

  const fetchCommentWriters = () => {
    setIsLoading(true);
    NamedCommunityService.getCommentWriter()
      .then((response) => {
        if (response.code === 200 && response.data) {
          setUsers(response.data ?? []);
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filteredUsers = users.filter((user) => user.Nickname?.toLowerCase().includes(searchQuery?.toLowerCase()));

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleConfirm = () => {
    setSelectedUser(focusedUser);
    if (onSelectWriter) {
      onSelectWriter(focusedUser);
    }
    handleClose();
  };

  return (
    <>
      {selectedUser ? (
        <SelectedWriter>
          <SelectedWriterName htmlFor={selectedUser?.ID}>선택작성자: {selectedUser?.Nickname}</SelectedWriterName>
          <RemoveWriter
            onClick={() => {
              setFocusedUser(null);
              setSelectedUser(null);
              if (onSelectWriter) {
                onSelectWriter(null);
              }
            }}
          >
            <X color='#ed2026' size={18} />
          </RemoveWriter>
        </SelectedWriter>
      ) : null}
      <TriggerButton type={'button'} onClick={handleOpen}>
        작성자 지정
      </TriggerButton>

      {isOpen && (
        <PopupOverlay>
          <PopupContainer>
            <PopupHeader>
              <Title>작성자지정</Title>
              <CloseButton onClick={handleClose}>×</CloseButton>
            </PopupHeader>

            <PopupContent>
              <SearchInput
                placeholder='ID 또는 내네임 2자 이상으로 입력하세요.'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </PopupContent>

            <UserList>
              {filteredUsers.map((user) => (
                <UserOption key={user.ID}>
                  <RadioInput
                    type='radio'
                    id={user.ID}
                    name='user'
                    value={user.ID}
                    checked={focusedUser?.ID === user.ID}
                    onChange={() => setFocusedUser(user)}
                  />
                  <UserLabel htmlFor={user.ID}>{user.Nickname}</UserLabel>
                </UserOption>
              ))}

              {isLoading && !users && (
                <LoadingContainer>
                  <Spinner />
                </LoadingContainer>
              )}
            </UserList>

            <PopupFooter>
              <ConfirmButton type={'button'} onClick={handleConfirm}>
                확인
              </ConfirmButton>
            </PopupFooter>
          </PopupContainer>
        </PopupOverlay>
      )}
    </>
  );
}
